<div class="category-buttons" [sxc-toolbar]="toolbarservice.toolbarForCategory()" >
  <ng-container *ngFor="let category of categories$ | async">
    <app-category-button [category]="category"></app-category-button>
  </ng-container>
</div>
